import React from 'react';
import styled from 'styled-components';
import {Button, FlexRow} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import Util from '../../../forecast-app/shared/util/util';

const Bar = styled.header`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 12px 24px;
	border-bottom: 1px solid #e0e0e0;
`;

const BackLink = styled.button`
	background: none;
	border: none;
	color: #0055ff;
	cursor: pointer;
	font-size: 14px;
	padding: 0;
	white-space: nowrap;
`;

const TitleGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	flex: 1;
	min-width: 0;
`;

const Eyebrow = styled.span`
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: #727483;
	white-space: nowrap;
`;

const ProjectName = styled.span`
	font-size: 15px;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const IdTag = styled.span<{$background: string}>`
	font-size: 11px;
	font-weight: 700;
	padding: 3px 8px;
	border-radius: 4px;
	background: ${p => p.$background};
	color: ${p => Util.getTextColorV2(p.$background)};
	white-space: nowrap;
`;

type Props = {
	onBack: () => void;
	onDownload: () => void;
	onPublish: () => void;
	publishDisabled?: boolean;
	projectName: string;
	projectIndicator: string;
	projectColor?: string | null;
};

const PageHeader: React.FC<Props> = ({
	onBack,
	onDownload,
	onPublish,
	publishDisabled,
	projectName,
	projectIndicator,
	projectColor,
}) => {
	const intl = useIntl();
	return (
		<Bar>
			<BackLink onClick={onBack} type="button" data-cy="quote-designer-back">
				{intl.formatMessage({id: 'quote_designer.cancel'})}
			</BackLink>
			<TitleGroup>
				<Eyebrow>{intl.formatMessage({id: 'quote_designer.header.create'})}</Eyebrow>
				<ProjectName>{projectName}</ProjectName>
				<IdTag $background={projectColor || '#e7e7f0'} data-cy="quote-designer-project-id">
					{projectIndicator}
				</IdTag>
			</TitleGroup>
			<FlexRow gap={'s'}>
				<Button emphasis="medium" onPress={onDownload} data-cy="download-quote-pdf-button">
					{intl.formatMessage({id: 'quote_designer.download'})}
				</Button>
				<Button onPress={onPublish} disabled={publishDisabled} data-cy="publish-quote-button">
					{intl.formatMessage({id: 'quote_designer.publish'})}
				</Button>
			</FlexRow>
		</Bar>
	);
};

export default PageHeader;
